<!-- components/LoginModal.vue -->
<template>
  <transition name="modal">
    <div v-if="visible" class="modal-mask" ><!--@click.self="hide"-->
      <div class="modal-container">
        <button class="close-btn" @click="hide">×</button>
        <div style="margin-top: 20px">
          <div>
              <div class="clear" style="margin-bottom: 22px;">
                <div style="width: 50%;float:left;" class="clear">
                  <div :class="chooseState == 1?'choose-btn':'none-choose'" style="float: right;margin-right: 15px;" @click="changeState(1)">
                    短<span :class="chooseState == 1?'choose-line':''">信登</span>录
                  </div>
                </div>
                <div style="width: 50%;float: right;" class="clear">
                  <div :class="chooseState == 2?'choose-btn':'none-choose'" style="float: left;margin-left: 15px;" @click="changeState(2)">
                    密<span :class="chooseState == 2?'choose-line':''">码登</span>录
                  </div>
                </div>
              </div>
              <div v-if="chooseState == 1">
                <el-form ref="smsForm"
                         :model="smsForm"
                         :rules="smsRules">
                  <el-form-item label="" prop="mobile">
                    <el-input v-model="smsForm.mobile"  class="input-with-icon" placeholder="请输入手机号" name="smsFormMobile" >
                      <template #prefix>
                        <img src="../assets/newhome/username.png" class="input-icon" />
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="" prop="code">
                    <el-input v-model="smsForm.code" class="input-with-icon" placeholder="请输入验证码" name="smsFormCode">
                      <template #prefix>
                        <img src="../assets/newhome/vercode.png" class="input-icon" />
                      </template>
                      <template #suffix>
                        <el-button
                          :disabled="isDisabled"
                          @click="sendCode"
                          class="get-code">
                          {{ buttonName }}
                        </el-button>
                      </template>
<!--                      <el-button slot="append" @click="sendCode" :disabled="isDisabled">{{ buttonName }}</el-button>-->
                    </el-input>
                  </el-form-item>
                </el-form>
                <div style="text-align: center">
                  <el-button class="login-btn" :loading="loading" @click="loginByCode">登录</el-button>
<!--                  <el-button class="login-btn" @click="loginByCode">登录/注册</el-button>-->
                </div>
                <div style="margin-top: 10px;">
<!--                  <div style="float: left;">-->
<!--                    <el-checkbox v-model="form.remember" label="记住账号" />-->
<!--                  </div>-->
                  <div class="apply-acc"  @click="registerAccount">
                    注册账号
                  </div>
                </div>

              </div>
              <!--          密码登录-->
              <div v-if="chooseState == 2">
                <el-form  ref="form"
                          :model="form"
                          :rules="rules">
                  <el-form-item label="" prop="mobile">
                    <el-input v-model="form.mobile"  placeholder="请输入账号，默认为手机号"  class="input-with-icon" name="formMobile">
                      <template #prefix>
                        <img src="../assets/newhome/username.png" class="input-icon" />
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="" prop="password">
                    <el-input :type="password" v-model="form.password" class="input-with-icon" placeholder="请输入密码，默认为手机号后六位" name="formPassword">
                      <template #prefix>
                        <img src="../assets/newhome/password.png" class="input-icon" style="margin-top: 12px;"/>
                      </template>
                      <el-image
                        style="width: 20px;cursor: pointer"
                        :src="eyeImage"
                        slot="append" @click="changePassword"></el-image>
                    </el-input>
                  </el-form-item>
                  <div style="text-align: center;">
                    <el-button class="login-btn" :loading="loading"   @click="login">登录</el-button>
                  </div>
                  <div style="margin-top: 10px;">
<!--                    <div style="float: left;">-->
<!--                      <el-checkbox v-model="form.remember" label="记住密码" />-->
<!--                    </div>-->
                    <div class="apply-acc"  @click="forgotPassword">
                      忘记密码
                    </div>
                  </div>
                </el-form>
              </div>
          </div>
          <!--          todo 2 -->
          <div class="forgot">
<!--            <el-checkbox v-model="checked" style="margin-right: 5px">-->
<!--            </el-checkbox>-->
            登录即同意<span class="register"  @click="openDialog('user')">《用户协议》</span>
            <span class="register" @click="openDialog('privacy')">《隐私协议》</span>
          </div>
          <!-- 协议弹窗组件 -->
          <agreement-dialog
            v-model="dialogVisible"
            :type="selectedType"

          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import eyeLine from '@/assets/eye-line.png'
import eyeOffLine from '@/assets/eye-off-line.png'
import cmsapis from '@/apis/home'
import apis from '@/apis/leader'
import tprapis from '@/apis/student/home'
import AgreementDialog from '@/components/agreementDialog.vue'
import store from '../store'
import router from '../router'
import eventBus from '@/utils/eventBus'
export default {
  components: {AgreementDialog},
  data () {
    return {
      chooseState: 1,
      eyeLine,
      eyeOffLine,
      visible: false,
      form: {
        username: '',
        password: ''
      },
      smsForm: {
        username: '',
        code: ''
      },
      rules: {
        mobile: [{required: true, trigger: 'blur', message: '请输入账号'}],
        password: [{required: true, trigger: 'blur', message: '请输入密码'}]
      },
      smsRules: {
        mobile: [{required: true, trigger: 'blur', message: '请输入账号'}],
        code: [{required: true, trigger: 'blur', message: '请输入验证码'}]
      },
      password: 'password',
      eyeImage: eyeLine,
      dialogVisibleUser: false,
      dialogVisibleSecret: false,
      dialogVisible: false, // 控制弹窗显示与隐藏
      selectedType: 'user', // 用于指定显示用户协议还是隐私协议
      loginConfig: {},
      buttonName: '获取验证码',
      isDisabled: false,
      time: 60,
      targetPath: {},
      loading: false
    }
  },
  created () {
    eventBus.$on('show-login', (path) => {
      this.targetPath = path
      console.log('targetPath', path)
    })
    // this.getLoginConfig()
  },
  methods: {
    sendCode () {
      if (this.smsForm.mobile) {
        const data = {mobile: this.smsForm.mobile, scene: 1}
        apis.sendSmsCode(data).then(res => {
          if (res) {
            this.$message.success('发送成功！')
            this.sendMsg(this.form.mobile)
          }
        })
      } else {
        this.$message.warning('请输入手机号')
      }
    },
    sendMsg (mobile) {
      if (mobile === '') {
      } else {
        let me = this
        me.isDisabled = true
        let interval = window.setInterval(function () {
          me.buttonName = me.time + 's'
          console.log(me.buttonName)
          --me.time
          if (me.time < 0) {
            me.buttonName = '重新获取'
            me.time = 60
            me.isDisabled = false
            window.clearInterval(interval)
          }
        }, 1000)
      }
    },
    showUser () {
      this.dialogVisibleUser = true
    },
    showSecret () {
      this.dialogVisibleSecret = true
    },
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
      // router.push({
      //   path: '/'
      // })
    },
    openDialog (type) {
      this.selectedType = type
      this.dialogVisible = true
      // 调试用，确认方法被调用
      console.log('打开', type, '协议弹窗')
    },
    changePassword () {
      this.password = this.password === 'password' ? 'text' : 'password'
      this.eyeImage = this.eyeImage === eyeLine ? eyeOffLine : eyeLine
    },
    forgotPassword () {
      this.hide()
      // this.checked = false
      router.push({
        path: '/forgotpassword'
      })
    },
    loginByCode () {
      // if (this.checked === false) {
      //   this.$message.info('请勾选用户协议及隐私协议')
      //   return
      // }
      this.$refs['smsForm'].validate(async (valid) => {
        if (valid) {
          this.loading = true
          const data = await apis.loginSms(this.smsForm)
          if (data) {
            const { code, msg, accessToken, refreshToken } = data
            if (code) {
              this.$message.error(msg)
            } else {
              this.handleConfig(accessToken, refreshToken)
            }
          }
          this.loading = false
        }
      })
    },
    login () {
      // if (this.checked === false) {
      //   this.$message.info('请勾选用户协议及隐私协议')
      //   return
      // }
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.loading = true
          const data = await apis.login(this.form)
          if (data) {
            const { code, msg, accessToken, refreshToken } = data
            if (code) {
              this.$message.error(msg)
            } else {
              this.handleConfig(accessToken, refreshToken)
            }
          }
          this.loading = false
        }
      })
    },
    async handleConfig (accessToken, refreshToken) {
      try {
        // 更安全的令牌存储方式（这里保留原逻辑，但建议评估安全性）
        localStorage.setItem('refreshToken', refreshToken)
        localStorage.setItem('accessToken', accessToken)
        this.$cookie.set('token', accessToken, '1d')

        // 获取并存储用户信息
        const {user} = await tprapis.getNewUser()
        store.commit('SET_USER', user)
        localStorage.setItem('user', JSON.stringify(user))

        // 确保登录状态设置完成
        await store.dispatch('login', accessToken)
        // 路由跳转逻辑
        const redirectPath = this.targetPath
        console.log('redirectPath', redirectPath)
        if (redirectPath && redirectPath.path) {
          console.log(redirectPath.path)
          console.log(redirectPath.query)
          try {
            await router.push({
              path: redirectPath.path,
              query: redirectPath.query
            })
          } catch (err) {
            console.error('路由跳转失败:', err)
            await router.push('/') // 失败后跳转到默认页
          }
        } else {
          window.location.reload()
        }
        this.$message.success('登录成功')
        this.visible = false
      } catch (error) {
        console.error('登录配置处理失败:', error)
        this.$message.error('登录处理失败')
      }
    },
    getLoginConfig () {
      cmsapis.getLoginConfig().then(res => {
        this.loginConfig = res
      })
    },
    changeState (state) {
      this.chooseState = state
    },
    registerAccount () {
      this.hide()
      // this.checked = false
      router.push({
        path: '/register'
      })
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.modal-container {
  background: white;
  padding: 33px 33px 20px 33px;
  border-radius: 8px;
  width: 318px;
  position: relative;
}
.get-code{
  padding: 13px 10px;
  font-size: 12px;
  color: #409EFF;
  border: none;
  border-left: 1px solid #e4e7ed;
}

.close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.modal-enter-active, .modal-leave-active {
  transition: opacity 0.3s;
}

.modal-enter, .modal-leave-to {
  opacity: 0;
}
.login-btn{
  background-color:#2A78FF;
  height: 40px;
  line-height: 10px;
  width: 100%;
  border: none;
  font-weight: 500;
  font-size: 16px;
  color: rgba(255,255,255,0.9);
  border-radius: 3px;
  margin: 5px 0px;
}
.apply-acc{
  float:right;
  font-weight: 500;
  font-size: 14px;
  margin-top: 2px;
  cursor: pointer;
  color: #2A78FF;
}
.agreement{
  position: relative;
  z-index: 1000;
  max-height: 400px;
  overflow-y: auto;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  font-size: 14px;
  line-height: 1.6;
}
.login-footer{
  margin-top: 30px;
  font-size: 14px;
  text-align: center;
  line-height: 20px;
}
.register{
  cursor: pointer;
  color: #285ADC;
}

.choose-line{
  border-bottom: 2px solid #2A78FF;
  padding-bottom: 4px;
}

.forgot {
  font-size: 12px;
  text-align: center;
  color: #999999;
  margin-top: 55px;
}

.clear:after {
  content: '';
  display: block;
  clear: both;
}
.choose-btn{
  font-weight: bold;
  font-size: 18px;
  cursor: pointer;
  color: #2A78FF;
}
.input-icon{
  width: 16px;
  height: 16px;
  margin: 0px 0px 0px 4px;
}
.none-choose{
  font-weight: 500;
  font-size: 18px;
  cursor: pointer;
  color: #666666;
}
.input-with-icon {
  width: 100%;
}
/deep/.el-tabs--border-card{
  box-shadow: none!important;
}
@media (max-width: 950px) {
  .modal-container {
    width: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loginModalV2.vue